import { FC } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import { editFormDataAF, EditFormMode, ICourseDto } from "@ryde/shared";

import {
  CourseDeepRecalculateButton,
  CourseRebuildRouteDropdown,
} from "../../../drawers/components/course-edit";
import { HeaderRightButtonsStyled } from "../../../header";
import { LayoutRightHistoryButton } from "../../../right";
import { CourseMeasuredTimesButton } from "./course-measured-times-button";

export const CourseHeaderButtons: FC = () => {
  const { entity, mode } = useCrudEditContext<ICourseDto>();
  const courseDto = useRecoilValue<Partial<ICourseDto> | undefined>(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );

  return (
    <HeaderRightButtonsStyled className="CourseDrawer-HeaderButtons">
      <CourseMeasuredTimesButton courseDto={courseDto} />
      <CourseDeepRecalculateButton courseDto={courseDto} />
      <CourseRebuildRouteDropdown courseDto={courseDto} />
      <LayoutRightHistoryButton entity={entity} dtoId={courseDto?.id} />
    </HeaderRightButtonsStyled>
  );
};
